import { Controller } from "@hotwired/stimulus"

// Auto-refreshes the parent turbo frame when a mileage allowance is pending.
// Stops after max retries or when the pending state is resolved.
// Retry count is persisted in sessionStorage to survive page/frame reloads.
export default class extends Controller {
  static values = {
    timesheetId: Number,
    interval: { type: Number, default: 5000 },
    maxRetries: { type: Number, default: 6 },
  }

  get storageKey() {
    return `pending-allowance-retries-${this.timesheetIdValue}`
  }

  connect() {
    this.retryCount = parseInt(sessionStorage.getItem(this.storageKey) || "0", 10)

    if (this.retryCount >= this.maxRetriesValue) {
      this.clearRetryCount()
      return
    }

    this.scheduleRefresh()
  }

  disconnect() {
    this.cancelRefresh()
  }

  scheduleRefresh() {
    this.timer = setTimeout(() => this.refresh(), this.intervalValue)
  }

  cancelRefresh() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  }

  refresh() {
    this.retryCount++
    sessionStorage.setItem(this.storageKey, this.retryCount.toString())

    if (this.retryCount >= this.maxRetriesValue) {
      this.clearRetryCount()
      return
    }

    // Find the closest turbo frame ancestor and reload it
    const frame = this.element.closest("turbo-frame")
    if (frame) {
      frame.reload()
    } else {
      // No turbo frame (e.g. show page) — reload the full page
      window.location.reload()
    }
  }

  clearRetryCount() {
    sessionStorage.removeItem(this.storageKey)
  }
}
